export default {
    url: '',	//获取签名url
    corp: '',	//
    emapPrefixPath: '',	//emap路径
    uploadImgsToEmapUrl: ''	//上传图片接口地址
};



// WEBPACK FOOTER //
// ./src/dd/defaults.js